module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_10_Ipad.5e5f4f1c.gif";